import React, { useEffect, useState } from "react";
import {
  CircularProgress, CssBaseline, Grid, Box, Button, Dialog, DialogTitle, DialogContent, DialogContentText,
  DialogActions
} from "@mui/material";
import Textfield from "../components/shared/textfield";
import MetaDecorator from "../services/meta_decorator";
import { useParams } from "react-router-dom";
import Checkbox from '@mui/material/Checkbox';
import { green, red } from "@mui/material/colors";
import AcceptAndValidate from "../components/login/acceptandvalidate";
import AccessLocalStorage from "../services/localStorage";
import {getApiUrl} from "../services/api_service";
import 'sweetalert/dist/sweetalert.css';

// const useStyles = makeStyles((theme) => ({
//   paper: {
//     padding: theme.spacing(8),
//     margin: "auto",
//     maxWidth: 1100,
//     borderRadius: 9,
//   },
//   maintitle: {
//     fontWeight: "bold",
//     fontSize: 24,
//     margin: "auto",
//     color: "#115C71",
//   },
//   buttonInverted: {
//     width: 100,
//     height: 30,
//     background: "#FFFFFF",
//     border: "1px solid #FF767E",
//     boxSizing: "border-box",
//     borderRadius: 9,
//     textTransform: "unset",
//     color: "#FF767E",
//     "&:hover": {
//       color: "#FFFFFF",
//       background: "#FF767E",
//     },
//   },
//   wrongText: {
//     color: "#FF767E",
//     fontSize: 13,
//   },
// }));

// const button = {
//   width: 140,
//   height: 40,
//   background: "#FF767E",
//   border: "1px solid #FF767E",
//   boxSizing: "border-box",
//   borderRadius: 2,
//   textTransform: "unset",
//   color: "#FFFFFF",
//   "&:hover": {
//     color: "#000000",
//     background: "#FF767E",
//   },
// };

function useWindowSize() {
  const [size, setSize] = useState([window.innerHeight, window.innerWidth]);

  useEffect(() => {
    const handleResize = () => {
      setSize([window.innerHeight.toExponential, window.innerWidth]);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return size;
}
export default function AcceptInvite() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { id } = useParams();
  const [width] = useWindowSize();

  const [invitestatus, setInviteStatus] = useState(null);
  const [tos, setTOS] = useState(false);
  const [verified, setVerified] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [org, setOrg] = useState("");
  const [showValidationError, setShowValidationError] = useState(false);
  const [status, setStatus] = useState({ success: '', error: '', showModal: false });
  const [loading, setLoading] = useState(false);
  const ls = new AccessLocalStorage();

  const loadInvitation = () => {
    setLoading(true);
    fetch(getApiUrl() + "/Account/getinvitation/" + id).then(resp => {
      setLoading(false);
      if (resp.status === 200) {
        resp.json().then(data => {
          
          setName(data.name);
          setEmail(data.email);
          setPhone(data.phone === null ? "" : data.phone);
          setOrg(data.serviceDepartment === null ? "" : data.serviceDepartment);
          setInviteStatus("verify");
        });
      } else {
        resp.json().then(data => {
          setInviteStatus(data.error);
        });
      }
    }).catch(err => {
      setLoading(false);
      setStatus({ success: '', error: 'Unable to contact server, check your internet connection.', showModal: false });
    });
  }
  useEffect(() => {
    if (ls.hoursPassedSinceLastOTPSent() > 2) {
      ls.removeOTPSentCount();
      ls.removeOTPSentDate();
    }
    loadInvitation();
  }, []);

  

  const sendingOTPAllowed = () => {
    if (ls.getOTPSentCount() >= 5) {
      let b = ls.hoursPassedSinceLastOTPSent() >= 0 && ls.hoursPassedSinceLastOTPSent() <= 2;
      return !b;
    }
    return true;
  }

  const generateOTP = () => {

    if (email === "" || phone === "" || name === "" || org === "")
      return;
    if (!sendingOTPAllowed()) {
      setStatus({ showModal: false, success: '', error: 'You have exhausted all attempts, please wait for ' + Math.ceil(2 - ls.hoursPassedSinceLastOTPSent()) + ' hours.' });
      return;
    }
    setLoading(true);
    fetch(getApiUrl() + "/Account/generateotp", {
      method: "post", headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id, name, email, phone, serviceDepartment: org, hospitalCarefacility: "" })
    }).then(resp => {
      setLoading(false);
      if (resp.status === 200) {
        ls.setOTPSentCount(ls.getOTPSentCount() + 1);
        setStatus({ success: 'A six digit passcode has been sent to your registered phone number and email.', error: '', showModal: true });
      } else {
        resp.json().then(data => {
          setStatus({ success: '', error: data.error, showModal: false });
        });
      }
    }).catch(err => {
      setLoading(false);
      setStatus({ success: '', error: 'Unable to contact server, check your internet connection.', showModal: false });
    });
  }

  const renderInviteMessage = (message) => {
    return <Box sx={{ bgcolor: "background.main" }}>
      <Grid container direction="row" justifyContent="center" alignItems="center" style={{ minHeight: "100vh" }}>
        <Box style={{ background: "#ffffff", width: "80%" }} py={5}>
          <Box style={{ margin: "50px 0px" }} textAlign="center">
            <img src='../Logo_Option_1.svg' alt='logo' ></img>
          </Box>
          <h2 style={{ margin: "50px 0px 100px 0px", padding: "", fontWeight: "bold", textAlign: "center" }}>{message}</h2>
        </Box>
      </Grid>
    </Box>;
  }

  const renderUI = () => {
    if (invitestatus === "accepted")
      return renderInviteMessage("Invitation is accepted and link is no longer valid.");
    else if (invitestatus === "no invite")
      return renderInviteMessage("No valid invitation found.");
    else if (invitestatus === "forbidden")
      return renderInviteMessage("No access to Dashboard for this role.");
    else if (invitestatus === "withdrawn")
      return renderInviteMessage("Invitation withdrawn.");
    else if (invitestatus === "declined")
      return renderInviteMessage("Invitation declined.");
    else if (invitestatus === "not found")
      return renderInviteMessage("Invitation not found.");
    else if (invitestatus === "expired")
      return renderInviteMessage("Invitation Expired");
    else if (invitestatus === "verify")
      return renderVerifyForm();
    else if (invitestatus === "validateotp") {
      return <AcceptAndValidate width={width} id={id} email={email} />
    }
  }

  const renderError = () => {
    if (status.error !== "") {
      if (status.showModal)
        return <Dialog
          open={status.error !== ""}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            {"Warning"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <div style={{
                color: "#545454",
                fontSize: "1.125em",
                fontWeight: "400",
                lineHeight: "normal",
                textAlign: "center",
                wordWrap: "break-word",
                wordBreak: "break-word", maxWidth: "400px", marginTop: "20px"
              }}>
              {status.error}</div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type="button" variant={"contained"} style={{
                marginBottom: "20px", backgroundColor: "#4bc0a9", color: "#ffffff", borderRadius: "9px",
                height: "41px"
              }} onClick={() => { setStatus({ success: status.success, error: '', showModal: false }); }} autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>;
      else
        return <Box m={1} textAlign={"center"} color={red}>{status.error}</Box>;
    }
    else return null;
  }

  const renderSuccess = () => {
    if (status.success !== "") {
      if (status.showModal)
        return <Dialog
          open={status.success !== ""}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <div style={{
                color: "#545454",
                fontSize: "1.125em",
                fontWeight: "400",
                lineHeight: "normal",
                textAlign: "center",
                wordWrap: "break-word",
                wordBreak: "break-word", maxWidth: "400px", marginTop: "20px"
              }}>
                {status.success}
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Button type="button" variant={"contained"}
              color="secondary" style={{
                marginBottom: "20px", backgroundColor: "#4bc0a9", color: "#ffffff", borderRadius: "9px",
                height: "41px"
              }} onClick={() => {
                if (status.success.indexOf("six digit passcode") > -1)
                  setInviteStatus("validateotp");
                setStatus({ success: '', error: status.error, showModal: false });
              }} autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>;
      else
        return <Box m={1} textAlign={"center"} color={green}>{status.success}</Box>;
    }
    else return null;
  }

  const renderFieldValidation = (field, notAllowedVal) => {
    return (showValidationError && field === notAllowedVal) ? <div style={{ color: "rgb(220, 53, 69)" }}>Required</div> : null;
  }

  const renderVerifyForm = () => {
    return (<Box sx={{ bgcolor: "background.main" }}>
      <Grid container >
        {width >= 902 && <Grid item md={6} style={{ minHeight: "100vh" }}></Grid>}
        <Grid style={{ background: "#ffffff", minHeight: "100vh" }} item md={6}>
          <Box p={2} py={4} textAlign="center">
            <img src='../Logo_Option_1.svg' alt='logo' ></img>
          </Box>
          <h3 style={{ fontWeight: "bold", textAlign: "center" }} p={3}>Verify Information</h3>
          <form onSubmit={(e) => { e.preventDefault(); setShowValidationError(true); generateOTP(); }}>
            <Box py={1} style={{ margin: "0 auto", width: "400px" }}>
              <Textfield
                title={"Full Name"}
                id={"name"}
                required={"true"}
                maxCharacterLimit={50}
                value={name}
                name={"name"}
                placeholder={"Your Name"}
                onChange={(e) => { setName(e.target.value); }}
              />
              {renderFieldValidation(name, "")}
            </Box>
            <Box py={1} style={{ margin: "0 auto", width: "400px" }}>
              <Textfield
                title={"Email"}
                required={true}
                readOnly={true}
                value={email}
                maxCharacterLimit={145}
                name={"email"}
              />
            </Box>
            <Box py={1} style={{ margin: "0 auto", width: "400px" }}>
              <Textfield
                title={"Phone Number"}
                required={true}
                maxCharacterLimit={20}
                value={phone}
                placeholder={"Your Phone"}
                onChange={(e) => { setPhone(e.target.value); }}
              />
              {renderFieldValidation(phone, "")}
            </Box>
            <Box py={1} style={{ margin: "0 auto", width: "400px" }}>
              <Textfield
                title={"Name of the Hospital or Organization"}
                required={true}
                value={org}
                maxCharacterLimit={100}
                placeholder={"Hospital or Organization"}
                onChange={(e) => { setOrg(e.target.value); }}
              />
              {renderFieldValidation(org, "")}
            </Box>
            <Box py={1} style={{ margin: "0 auto", maxWidth: "400px" }}>
              {verified ? <Checkbox defaultChecked onChange={() => { setVerified(false) }} /> : <Checkbox onChange={() => { setVerified(true) }} />} Verify the information provided in form and check this box, before proceeding.
            </Box>
            <Box py={1} style={{ margin: "0 auto", maxWidth: "400px" }}>
              {tos ? <Checkbox defaultChecked onChange={() => { setTOS(false) }} /> : <Checkbox onChange={() => { setTOS(true) }} />} By registering I am agreeing to <a style={{ color: "#4bc0a9", textDecoration: "auto" }} href="https://www.enrichmycare.com/our-policies/#Terms" rel="noreferrer" target="_blank">Terms of Service</a> and <a style={{ color: "#4bc0a9" }} href="https://www.enrichmycare.com/our-policies/#Privacy"  rel="noreferrer" target="_blank">Privacy Policy</a>
            </Box>
            {renderError()}
            {renderSuccess()}
            <Box py={1} mb={3} style={{ textAlign: "center", margin: "0 auto", width: "400px" }}>
              <Button type="submit" variant={tos && verified ? "contained" : "outlined"} disabled={!tos || !verified || loading}
                color="secondary" >
                {loading ? <CircularProgress color="inherit" /> : "Verify & Accept"}
              </Button>
            </Box>
          </form>
        </Grid>
      </Grid>
    </Box>);
  }

  return (
    <Box>
      <CssBaseline />
      <MetaDecorator title={"Professional Invite"} description={""} />
      {renderUI()}
    </Box>
  );
}
